// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".price-filter[data-v-19940032]{display:flex;flex-direction:column;flex:1}.price-filter>p[data-v-19940032]{color:#fff;line-height:130%;padding-bottom:5px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
